div:has(#cardNumber,#cardCvc,#cardExpiry) .focus_CardElements_e19564b{border-color:var(--form-highlight)}